import * as _ from "lodash";
import moment from "moment";
import React from "react";
import Calendar from "react-calendar";
import { caretBack, caretForward, playBack, playForward } from "ionicons/icons";
import { IonIcon, IonPopover } from "@ionic/react";

import "./EWPCalendar.scss";

interface EWPCalendarProps {
  calendarAnchor: null | undefined | Event;
  selectedDate: Date;
  removeCalendarAnchor: () => void;
  onDateChange: (date: Date) => void;
  maxDate?: Date;
  minDate?: Date;
}
export const EWPCalendar = (props: EWPCalendarProps) => {
  const {
    calendarAnchor,
    removeCalendarAnchor,
    selectedDate,
    onDateChange,
    maxDate,
    minDate,
  } = props;

  return (
    <IonPopover
      className="ewp-calendar-popover"
      mode="ios"
      isOpen={!_.isEmpty(calendarAnchor)}
      event={!_.isNull(calendarAnchor) ? calendarAnchor : undefined}
      onDidDismiss={() => removeCalendarAnchor()}
      showBackdrop={false}
    >
      <Calendar
        className="ewp-custom-calendar"
        value={selectedDate}
        onChange={(date: Date | Date[]) => {
          onDateChange(date as Date);
          removeCalendarAnchor();
        }}
        calendarType="US"
        minDetail="year"
        maxDate={maxDate}
        minDate={minDate}
        prevLabel={<IonIcon mode="md" icon={caretBack} />}
        nextLabel={<IonIcon mode="md" icon={caretForward} />}
        prev2Label={<IonIcon mode="md" icon={playBack} />}
        next2Label={<IonIcon mode="md" icon={playForward} />}
        formatShortWeekday={(local: string, date: Date) => {
          const weekday = moment(date).format("ddd")[0];
          return weekday;
        }}
        tileClassName="ewp-profile-calendar-tile"
      />
    </IonPopover>
  );
};
